var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Dialog, DialogContent, Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CloseWithoutBorder, SearchIconGray } from '../../../assets/images';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { JournalVoucherAccountPagingAPICall, JournalVoucherContactListAPICall, JournalVoucherPersonAPICall } from '../services/apiCalls';
import { JournalVoucherAccountPagingUrl, JournalVoucherContactPagingUrl, JournalVoucherKeys } from '../services/entity';
var JournalDetails = function (props) {
    var _crud$JournalVoucherK, _crud$JournalVoucherK2, _crud$JournalVoucherK3, _value$name2, _value$name3, _openDialog$selectedR4;
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? 'ProductIssueDetails' : _a, error = props.error;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _b = useState(0), totalDebitAmount = _b[0], setTotalDebitAmount = _b[1];
    var _c = useState(0), totalCreditAmount = _c[0], setTotalCreditAmount = _c[1];
    var dispatch = useDispatch();
    var initialRows = (_crud$JournalVoucherK = crud[JournalVoucherKeys.Get]) === null || _crud$JournalVoucherK === void 0 ? void 0 : _crud$JournalVoucherK.data;
    var _d = useState(""), searchValue = _d[0], setSearchValue = _d[1];
    var _e = useState({
        selectedRow: {},
        openListDialog: false,
        dialogFor: ""
    }), openDialog = _e[0], setOpenDialog = _e[1];
    useEffect(function () {
        if ((initialRows === null || initialRows === void 0 ? void 0 : initialRows.length) > 0 && onDataChange)
            onDataChange(null, initialRows, null);
    }, [initialRows]);
    useEffect(function () {
        JournalVoucherAccountPagingAPICall({
            key: JournalVoucherKeys.JournalVoucherAccountList,
            url: JournalVoucherAccountPagingUrl
        });
    }, []);
    var calculateTotals = function (rows) {
        var totalDebit = rows.reduce(function (sum, row) { return sum + (row.DebitAmount || 0); }, 0);
        var totalCredit = rows.reduce(function (sum, row) { return sum + (row.CreditAmount || 0); }, 0);
        setTotalDebitAmount(totalDebit);
        setTotalCreditAmount(totalCredit);
    };
    var columns = [{
            type: 'searchSelect',
            field: 'AccountName',
            headerName: 'Account',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            minWidth: 250,
            valueOptions: (_crud$JournalVoucherK2 = (_crud$JournalVoucherK3 = crud[JournalVoucherKeys.JournalVoucherAccountList]) === null || _crud$JournalVoucherK3 === void 0 ? void 0 : _crud$JournalVoucherK3.data) !== null && _crud$JournalVoucherK2 !== void 0 ? _crud$JournalVoucherK2 : [],
            placeholder: 'Enter account',
            moreButtonText: 'Search More...',
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.DisplayName; },
            getOptionKey: function (option) { return option === null || option === void 0 ? void 0 : option.id; },
            onMoreButtonClick: function (event, state) {
                onSearchMoreClick(event, state, "account");
            },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.DisplayName; },
            valueGetter: function (val, row) { return (row === null || row === void 0 ? void 0 : row.JournalTypeId) && {
                id: row === null || row === void 0 ? void 0 : row.JournalTypeId,
                DisplayName: row === null || row === void 0 ? void 0 : row.Account
            }; },
            valueSetter: function (value, row, column) {
                var obj = {
                    // ...row,
                    id: row === null || row === void 0 ? void 0 : row.id,
                    JournalTypeId: value === null || value === void 0 ? void 0 : value.id,
                    IsSubLedger: value === null || value === void 0 ? void 0 : value.IsSubLedger,
                    Account: value === null || value === void 0 ? void 0 : value.DisplayName,
                    AccountName: value,
                    TenantChartOfAccountId: value === null || value === void 0 ? void 0 : value.TenantChartOfAccountId
                };
                return obj;
            }
        }, {
            type: 'searchSelect',
            field: 'Name',
            headerName: 'Contact',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            minWidth: 250,
            // valueOptions: crud[JournalVoucherKeys.JournalVoucherContactList]?.data ?? [],
            apiKey: JournalVoucherKeys.JournalVoucherContactList,
            placeholder: 'Enter contact',
            moreButtonText: 'Search More...',
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.Name; },
            getOptionKey: function (option) { return option === null || option === void 0 ? void 0 : option.id; },
            onMoreButtonClick: function (event, state) {
                onSearchMoreClick(event, state, "contact");
            },
            getListData: JournalVoucherContactListAPICall,
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            valueGetter: function (val, row) { return ((row === null || row === void 0 ? void 0 : row.PersonId) || (row === null || row === void 0 ? void 0 : row.OrganizationId)) && {
                id: row !== null && row !== void 0 && row.PersonId ? row === null || row === void 0 ? void 0 : row.PersonId : row === null || row === void 0 ? void 0 : row.OrganizationId,
                Name: row === null || row === void 0 ? void 0 : row.Name
            }; },
            valueSetter: function (value, row, column) {
                console.log("value", value);
                var obj = _objectSpread(_objectSpread({}, row), {}, {
                    PersonId: (value === null || value === void 0 ? void 0 : value.Type) === "Person" ? value === null || value === void 0 ? void 0 : value.id : null,
                    Name: value === null || value === void 0 ? void 0 : value.Name,
                    OrganizationId: (value === null || value === void 0 ? void 0 : value.Type) === "Organization" ? value === null || value === void 0 ? void 0 : value.OrganizationId : null
                });
                return obj;
            }
        }, {
            type: 'number',
            field: 'DebitAmount',
            headerName: 'DebitAmount',
            editable: true,
            flex: 1,
            headerAlign: 'left'
        }, {
            type: 'number',
            field: 'CreditAmount',
            headerName: 'CreditAmount',
            editable: true,
            flex: 1,
            headerAlign: 'left'
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            headerAlign: 'left'
        }];
    var customActionColumnsForAccount = [{
            type: 'date',
            field: 'CreatedOn',
            headerName: 'Created date',
            valueFormatter: function (value) { return dayjs(value).format('DD MMM, YYYY'); },
            flex: 1
        }, {
            field: 'DisplayName',
            headerName: 'Display Name',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.DisplayName; },
            flex: 1
        }, {
            field: 'Code',
            headerName: 'Code',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Code; },
            flex: 1
        }, {
            field: 'StatusName',
            headerName: 'Status',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.StatusName; },
            flex: 1
        }];
    var customActionColumnsForContact = [{
            field: 'Name',
            headerName: 'Name',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            flex: 1
        }, {
            field: 'BranchCode',
            headerName: 'Code',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.BranchCode; },
            flex: 1
        }, {
            field: 'StatusName',
            headerName: 'Status',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.StatusName; },
            flex: 1
        }, {
            field: 'Type',
            headerName: 'Type',
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Type; },
            flex: 1
        }];
    var onDataChange = function (e, rows, details) {
        dispatch(setReducerState({
            key: JournalVoucherKeys.journalRowData,
            value: rows
        }));
        calculateTotals(rows);
        if (onChange)
            onChange(e, rows);
    };
    var searchAPICall = useCallback(function (search, dialogType) { return __awaiter(void 0, void 0, void 0, function () {
        var _openDialog$selectedR, apiCall, url, request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiCall = dialogType === "account" ? JournalVoucherAccountPagingAPICall : JournalVoucherPersonAPICall;
                    url = dialogType === "account" ? JournalVoucherAccountPagingUrl : JournalVoucherContactPagingUrl;
                    request = dialogType === "contact" ? {
                        search: search,
                        TenantChartOfAccountId: openDialog === null || openDialog === void 0 || (_openDialog$selectedR = openDialog.selectedRow) === null || _openDialog$selectedR === void 0 ? void 0 : _openDialog$selectedR.JournalTypeId
                    } : {
                        search: search
                    };
                    return [4 /*yield*/, apiCall({
                            key: dialogType === "account" ? JournalVoucherKeys.JournalVoucherAccountList : JournalVoucherKeys.JournalVoucherPersonList,
                            url: url,
                            request: request
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [openDialog]);
    var onSearchChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchValue(value);
                    return [4 /*yield*/, searchAPICall(value, openDialog.dialogFor)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDialogClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchValue("");
                    setOpenDialog({
                        selectedRow: {},
                        openListDialog: false,
                        dialogFor: ""
                    });
                    if (!(openDialog.dialogFor === "account")) return [3 /*break*/, 2];
                    return [4 /*yield*/, searchAPICall("", openDialog.dialogFor)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    dispatch(setReducerState({
                        key: JournalVoucherKeys.JournalVoucherPersonList,
                        value: null
                    }));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSearchMoreClick = function (e, state, dialogType) {
        setSearchValue(state === null || state === void 0 ? void 0 : state.inputValue);
        setOpenDialog({
            selectedRow: _objectSpread(_objectSpread({}, state === null || state === void 0 ? void 0 : state.row), {}, {
                search: state === null || state === void 0 ? void 0 : state.inputValue
            }),
            openListDialog: true,
            dialogFor: dialogType
        });
        if (dialogType === "account") {
            JournalVoucherAccountPagingAPICall({
                key: JournalVoucherKeys.JournalVoucherAccountList,
                url: JournalVoucherAccountPagingUrl,
                request: {
                    search: state === null || state === void 0 ? void 0 : state.inputValue
                }
            });
        }
    };
    var handleRowClick = function (row) {
        var _value$name;
        console.log("row", row);
        var updatedRowData = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.map(function (item) {
            var _openDialog$selectedR2;
            if ((item === null || item === void 0 ? void 0 : item.id) === (openDialog === null || openDialog === void 0 || (_openDialog$selectedR2 = openDialog.selectedRow) === null || _openDialog$selectedR2 === void 0 ? void 0 : _openDialog$selectedR2.id)) {
                var _openDialog$selectedR3;
                return (openDialog === null || openDialog === void 0 ? void 0 : openDialog.dialogFor) === 'account' ? _objectSpread(_objectSpread({}, item), {}, {
                    JournalTypeId: row === null || row === void 0 ? void 0 : row.id,
                    Account: row === null || row === void 0 ? void 0 : row.DisplayName,
                    AccountName: row,
                    id: openDialog === null || openDialog === void 0 || (_openDialog$selectedR3 = openDialog.selectedRow) === null || _openDialog$selectedR3 === void 0 ? void 0 : _openDialog$selectedR3.id,
                    IsSubLedger: row === null || row === void 0 ? void 0 : row.IsSubLedger,
                    TenantChartOfAccountId: row === null || row === void 0 ? void 0 : row.TenantChartOfAccountId
                }) : _objectSpread(_objectSpread({}, item), {}, {
                    PersonId: (row === null || row === void 0 ? void 0 : row.Type) === "Person" ? row === null || row === void 0 ? void 0 : row.id : null,
                    OrganizationId: (row === null || row === void 0 ? void 0 : row.Type) === "Organization" ? row === null || row === void 0 ? void 0 : row.OrganizationId : null,
                    Name: row === null || row === void 0 ? void 0 : row.Name
                });
            }
            return item;
        });
        onDataChange(null, updatedRowData, null);
        handleDialogClose();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Journal details",
        isCollapsible: true,
        columns: columns,
        rows: (_value$name2 = value[name]) !== null && _value$name2 !== void 0 ? _value$name2 : initialRows,
        onChange: onDataChange,
        dataGridProps: {
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            disableColumnSorting: true,
            hideFooter: true,
            pinnedRows: {
                bottom: ((_value$name3 = value[name]) === null || _value$name3 === void 0 ? void 0 : _value$name3.length) > 0 || (initialRows === null || initialRows === void 0 ? void 0 : initialRows.length) > 0 ? [{
                        id: "total",
                        Account: 'Total',
                        CreditAmount: totalCreditAmount,
                        DebitAmount: totalDebitAmount
                    }] : []
            },
            isRowSelectable: function (params) {
                var _params$row;
                return (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.isDisabled) !== true;
            },
            isCellEditable: function (params) {
                var _params$row2;
                if ((params === null || params === void 0 ? void 0 : params.row.id) === "total") {
                    return false;
                }
                if ((params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.isDisabled) === true) {
                    return false;
                }
                else if (params.field === "Name") {
                    var _params$row3, _params$row4;
                    return params.field === "Name" && (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.Account) && (params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.IsSubLedger);
                }
                else if (params.field === "Remarks") {
                    var _params$row5;
                    return params.field === "Remarks" && (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.Account);
                }
                else if (params.field === "DebitAmount") {
                    var _params$row6, _params$row7;
                    // handleOnChange(params)
                    return params.field === "DebitAmount" && !(params !== null && params !== void 0 && (_params$row6 = params.row) !== null && _params$row6 !== void 0 && _params$row6.CreditAmount) && (params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.Account);
                }
                else if (params.field === "CreditAmount") {
                    var _params$row8, _params$row9;
                    // handleOnChange(params)
                    return params.field === "CreditAmount" && !(params !== null && params !== void 0 && (_params$row8 = params.row) !== null && _params$row8 !== void 0 && _params$row8.DebitAmount) && (params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.Account);
                }
                return true;
            }
        },
        error: error === null || error === void 0 ? void 0 : error[name],
        validationModel: {
            CreditAmount: function (value) {
                var regex = /^\d+(\.\d{0,2})?$/;
                if (!(value === '' || regex.test(value))) {
                    return "Enter Correct value";
                }
            },
            DebitAmount: function (value) {
                var regex = /^\d+(\.\d{0,2})?$/;
                if (!(value === '' || regex.test(value))) {
                    return "Enter Correct value";
                }
            },
            PersonId: function (value, row) {
                if (!value && row.IsSubLedger) {
                    return "Enter Correct value";
                }
            }
            // Remarks: (value) => {
            //     if (value?.length > 500) {
            //         return "Value must be 500 or less";
            //     }
            // },
        }
    }), /*#__PURE__*/ React.createElement(Dialog, {
        id: "part-location-popup",
        open: openDialog === null || openDialog === void 0 ? void 0 : openDialog.openListDialog,
        onClose: handleDialogClose,
        fullWidth: true,
        maxWidth: "md"
    }, /*#__PURE__*/ React.createElement(DialogContent, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: "center",
        mt: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "popupsearch-inputbox",
        variant: "outlined",
        fullWidth: true,
        value: searchValue,
        className: "Search",
        onChange: function (e) {
            var inputValue = e.target.value;
            var filteredValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');
            if (inputValue === filteredValue || inputValue === '') {
                onSearchChange(filteredValue);
            }
        },
        name: "serial no",
        sx: {
            '& .MuiInputBase-input': {
                height: '30px'
            },
            '& .MuiOutlinedInput-root': {
                height: '40px'
            }
        },
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "start"
            }, /*#__PURE__*/ React.createElement("img", {
                src: SearchIconGray,
                alt: "Search-Icon-Gray"
            }))
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: "popup-close-icon",
        "aria-label": "close",
        onClick: handleDialogClose,
        sx: {
            right: 8
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: CloseWithoutBorder,
        id: "close-icon-popup",
        alt: "closeIcon",
        height: '24px',
        width: '24px'
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        mt: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: (openDialog === null || openDialog === void 0 ? void 0 : openDialog.dialogFor) === "account" ? JournalVoucherKeys.JournalVoucherAccountList : JournalVoucherKeys.JournalVoucherPersonList,
        getPagingData: (openDialog === null || openDialog === void 0 ? void 0 : openDialog.dialogFor) === "account" ? JournalVoucherAccountPagingAPICall : JournalVoucherPersonAPICall,
        pagingAPIRequest: {
            search: searchValue,
            TenantChartOfAccountId: (openDialog === null || openDialog === void 0 ? void 0 : openDialog.dialogFor) !== "account" && (openDialog === null || openDialog === void 0 || (_openDialog$selectedR4 = openDialog.selectedRow) === null || _openDialog$selectedR4 === void 0 ? void 0 : _openDialog$selectedR4.JournalTypeId)
        },
        columns: (openDialog === null || openDialog === void 0 ? void 0 : openDialog.dialogFor) === "account" ? customActionColumnsForAccount : customActionColumnsForContact,
        dataGridProps: {
            onRowClick: function (params) { return handleRowClick(params === null || params === void 0 ? void 0 : params.row); },
            disableColumnMenu: true,
            disableColumnSorting: true,
            hideFooter: true
        }
    })))));
};
export default JournalDetails;
